import { render, staticRenderFns } from "./PolymorphicReferenceUpdateScreen.vue?vue&type=template&id=4c81a7b0&"
import script from "./PolymorphicReferenceUpdateScreen.vue?vue&type=script&lang=js&"
export * from "./PolymorphicReferenceUpdateScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports